import { Injectable } from "@angular/core";

import { LoginFeatureState } from "../state";

import { SgaLoginTab } from "./sga-login.model";

@Injectable({
	providedIn: "root",
})
export class SgaLoginSelector {
	selectedLoginTab() {
		return (state: LoginFeatureState): SgaLoginTab | undefined => state.loginFeature?.sgaLogin.selectedLoginTab;
	}
}
